import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.4rem;
`;

export const Select = styled.select`
  position: relative;
  width: 100%;
  padding: 1.6rem;
  padding-right: 3rem;
  background-color: #1f1e25;
  // color: #5c576b;
  border: 0.1rem solid #4d495a;
  border-radius: 0.8rem;
  z-index: 100;
`;

export const GenderSelectBox = styled.div`
  width: 100%;
  display: flex;
  gap: 0.8rem;
`;

export const GenderCheckBox = styled.div`
  display: flex;
  gap: 1.2rem;
  width: 50%;
`;

export const ButtonBox = styled.div`
  display: flex;
  width: 100%;
  gap: 1.2rem;
`;
